@if (dialogOpen()) {
  <div
    class="dialog-bg"
    [class.transparent]="options().noGreyBackground && !isMobile()"
    animate.enter="simple-fade-in"
    animate.leave="simple-fade-out"
    [style.--animation-opacity]="backdropOpacity()"
    [style.opacity]="backdropOpacity()"
    (click)="close(undefined)"
  ></div>
}
@if (!isMobile()) {
  @if (dialogOpen()) {
    @if (options().layout === 'side') {
      <div
        class="sidebar"
        [class.no-bg]="options().noBackground"
        animate.enter="fade-left-in"
        animate.leave="fade-left-out"
      >
        <div class="sidebar-content spacing-x-{{ options().spacingX }} spacing-y-{{ options().spacingY }}">
          <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
      </div>
    } @else {
      <div
        class="dialog-item"
        [class.no-bg]="options().noBackground"
        animate.enter="scale-fade-in"
        animate.leave="scale-fade-out"
      >
        <div class="dialog-content dialog-content-desktop size-{{ options().size }}">
          <div
            class="dialog-inner-content dialog-inner-content-desktop size-{{ options().size }}"
            [style.min-height]="minHeight()"
          >
            <div
              class="dialog-box spacing-x-{{ options().spacingX }} spacing-y-{{ options().spacingY }}"
              [class.small-bottom]="options().hasSmallBottomPart"
              [style.max-height]="options().maxHeight ? 'min(' + options().maxHeight + 'px, calc(100vh - 40px))' : null"
            >
              @if (!options().hideClose) {
                <button
                  (click)="close(undefined)"
                  color="simple-gray"
                  appButton
                  name="DONTREPORT"
                  location="dialogs"
                  shape="round"
                  [iconButton]="true"
                  spacing="1"
                  data-test-id="close-dialog-button"
                  height="1"
                  class="close-button"
                >
                  <app-svg src="/assets/icons/cross.svg"></app-svg>
                </button>
              }
              <ng-container *ngTemplateOutlet="template"></ng-container>
            </div>
          </div>
        </div>
      </div>
    }
  }
} @else {
  @if (dialogOpen() && options().mobileAlignment !== 'top') {
    <div
      class="dialog-item dialog-item-mobile"
      [class.no-bg]="options().noBackground"
      [style.max-height]="maxHeight() + 'px'"
      animate.enter="fade-up-subtle-in"
      animate.leave="fade-up-subtle-out"
    >
      <div class="dialog-content size-{{ options().size }}">
        <div
          class="dialog-inner-content size-{{ options().size }} spacing-x-{{ options().spacingX }} spacing-y-{{
            options().spacingY
          }}"
          [class.small-bottom]="options().hasSmallBottomPart"
          [class.no-mobile-padding]="options().noMobilePadding"
          [style.max-height]="maxHeight() + 'px'"
        >
          <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
      </div>
    </div>
  } @else if (dialogOpen()) {
    <div
      class="dialog-item dialog-item-mobile top"
      [class.no-bg]="options().noBackground"
      [style.max-height]="maxHeight() + 'px'"
      animate.enter="fade-down-in"
      animate.leave="fade-down-out"
    >
      <div class="dialog-content size-{{ options().size }}">
        <div
          class="dialog-inner-content size-{{ options().size }} spacing-x-{{ options().spacingX }} spacing-y-{{
            options().spacingY
          }}"
          [class.small-bottom]="options().hasSmallBottomPart"
          [class.no-mobile-padding]="options().noMobilePadding"
          [style.max-height]="maxHeight() + 'px'"
        >
          <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
      </div>
    </div>
  }
}
<ng-template #template>
  <ng-template #placeholder></ng-template>
</ng-template>
